import React from 'react';
import DataResource from './../../../common/DataResource'
import Panel from './../../../common/layout/Panel'

export default class extends React.Component {
    render () {
        var carrierId = this.props.match.params.carrier_id;
        const data = {
            url: `/admin/carriers/carriers/${carrierId}/voicecdr`,
            limit: 50,
            offset: 0,
            filter: {},
            datalen: 0,
            datarows: [],
            servermeta: [],
            loading: false,
            userfilter:
            [
                {
                    source: 'ATRTIMESTAMP',
                    label: 'Date',
                    type: 'date_range',
                    default: {'from' : new Date(), 'to': new Date() }
                },
                {
                    source: 'ATRDESTADDR',
                    label: 'Dest. Address',
                    type: 'text',
                    default: ''
                },
                {
                    source: 'ATRSRCADDR',
                    label: 'Source Address',
                    type: 'text',
                    default: ''
                }
            ],
            metadata:
                [
                    {
                        label: 'id',
                        source: 'ATRCDRID',
                        type: 'primary',
                        visible: false
                    },
                    {
                        label: 'Stop Time',
                        source: 'ATRENTM',
                        type: 'datetime',
                    },
                    {
                        label: 'Billed Duration',
                        source: 'ATRVOBILLDUR',
                        type: 'time'
                    },
                    {
                        label: 'Source IP',
                        source: 'ATRCRIP',
                        type: 'text'
                    },
                    {
                        label: 'Source Number',
                        source: 'ATRSRCNUM',
                        type: 'text'
                    },
                    {
                        label: 'Dest Number',
                        source: 'ATRBILLDSTNUM',
                        type: 'text'
                    },
                    {
                        label: 'Destination Name',
                        source: 'ATRBILLDSTDSCR',
                        type: 'text'
                    },
                    {
                        label: 'Billed Amount',
                        source: 'ATRVOAMNT',
                        type: 'money4'
                    },
                    {
                        label: 'Currency',
                        source: 'SELL_CURRENCY_NAME',
                        type: 'text'
                    },
                    {
                        label: 'Cost',
                        source: 'ATRVIAMNT',
                        type: 'money4'
                    },
                    {
                        label: 'Currency',
                        source: 'BUY_CURRENCY_NAME',
                        type: 'text'
                    },
                    {
                        label: 'Profit',
                        source: 'PROFIT',
                        type: 'money4'
                    },
                    {
                        label: 'Currency',
                        source: 'PROFIT_CURRENCY_NAME',
                        type: 'text'
                    },
                    {
                        label: 'View',
                        url: 'admin/carriers/carriers/'+ carrierId +'/voicecdr/',
                        type: 'popup',
                        title: 'Voce CDR Details',
                        fields: [
                            {
                                label: 'Call ID',
                                source: 'ATRCALLID',
                                type: 'text'
                            },
                            {
                                label: 'Setup Time',
                                source: 'ATRSETM',
                                type: 'datetime',
                            },
                            {
                                label: 'Connect Time',
                                source: 'ATRSTTM',
                                type: 'datetime',
                            },
                            {
                                label: 'Stop Time',
                                source: 'ATRENTM',
                                type: 'datetime',
                            },
                            {
                                label: 'Actual Duration',
                                source: 'ATRDURATION',
                                type: 'time',
                            },
                            {
                                label: 'Disconnect Code',
                                source: 'ATRDISCCAUSE',
                                type: 'text',
                            },
                            {
                                label: 'Billed Duration',
                                source: 'ATRVOBILLDUR',
                                type: 'time'
                            },
                            {
                                label: 'Source IP',
                                source: 'ATRCRIP',
                                type: 'text'
                            },
                            {
                                label: 'Source Number',
                                source: 'ATRSRCNUM',
                                type: 'text'
                            },
                            {
                                label: 'Dest Number',
                                source: 'ATRBILLDSTNUM',
                                type: 'text'
                            },
                            {
                                label: 'Destination Name',
                                source: 'ATRBILLDSTDSCR',
                                type: 'text'
                            },
                            {
                                label: 'Billed Amount',
                                source: 'ATRVOAMNT',
                                type: 'money4'
                            },
                            {
                                label: 'Currency',
                                source: 'SELL_CURRENCY_NAME',
                                type: 'text'
                            },
                            {
                                label: 'Cost',
                                source: 'ATRVIAMNT',
                                type: 'money4'
                            },
                            {
                                label: 'Currency',
                                source: 'BUY_CURRENCY_NAME',
                                type: 'text'
                            },
                            {
                                label: 'Profit',
                                source: 'PROFIT',
                                type: 'money4'
                            },
                            {
                                label: 'Currency',
                                source: 'PROFIT_CURRENCY_NAME',
                                type: 'text'
                            },
                        ]
                    }
                ]
        }
        return (
            <Panel title = "Voice CDR">
                <DataResource
                    data = {data}
                    {...this.props} 
                />
            </Panel>
        )
    }
}
   